@let _reply = reply();

<section [attr.data-reply-id]="_reply.id" class="flex flex-col pl-20">
    <!-- Reply content -->
    <span class="reply-content body-medium pl-3 mb-2">{{_reply.description}}</span>

    <span class="flex body-small text-lendio-warm-gray-400 mb-2">
        {{userFullName(_reply.creator_user)}}
        <span class="ml-auto mb-2">
            {{relativeDate(_reply.createdTimestamp, true)}}
        </span>
    </span>
</section>
